/* eslint-disable */
<template>
	<section class="ncd-top-container">
		<!-- Search Backdrop (Blur effect) -->
		<div
			v-if="searchActive"
			class="search-ba-ckdrop"
			@click="closeSearchDropdown"
		></div>
		<div
			@click="goToProfileVisibility"
			v-if="$route.name == 'Homepage' && !isFirstTimeUser"
			class="ncd-top-firstcard fam-inter fs-12 d-flex align-items-center"
		>
			<img
				src="../../assets/NewDashboard/Mobiledesign/eye.svg"
				class="eyeicon-shadow"
				alt=""
			/>
			<span class="color-2E452D fw-LM ml-2"
				>Your profile was seen by
				<span class="fw-B text-blue"> {{ recruitersCount }} Recruiters</span>.
				Check now!
			</span>
			<img
				src="../../assets/NewDashboard/Mobiledesign/arw.svg"
				alt=""
				class="pointer"
			/>
		</div>
		<div class="ncd-top-search-container">
			<section class="d-flex align-items-center w-100">
				<div class="position-relative d-flex side-nav-main">
					<img
						src="../../assets/NewDashboard/Mobiledesign/menuicon.svg"
						alt=""
						class="ncd-menu-icon"
						@click="showsidebar = !showsidebar"
					/>
					<div
						class="mh-side-nav"
						@focusout="showsidebar = false"
						:class="{
							mhfixedwidth: showsidebar,
							mhtrans: !showsidebar,
						}"
					>
						<div class="mh-side-menu-main">
							<MainLeftpart :expanded="true" @navigate="showsidebar = false" />
						</div>
					</div>
				</div>
				<div class="w-75 ml-3" v-if="$route.name == 'Homepage'">
					<div class="fw-B fam-inter text-white fs-16">
						Hi {{ firstName }}!
						<img
							src="../../assets/NewDashboard/Mobiledesign/lightbluearw.svg"
							alt=""
							class="pointer"
							@click="goToResumeBuilder"
						/>
					</div>
					<div
						class="fam-inter fw-LM color-E0E0E0 w-100 d-flex align-items-center"
					>
						<div style="min-width: auto; max-width: 40%" class="text-truncate">
							{{ jobTitle }}
						</div>
						<template v-if="location && location.trim()">
							&nbsp; • &nbsp;
							<div
								style="min-width: auto; max-width: 40%"
								class="text-truncate"
							>
								{{ location }}
							</div>
						</template>
					</div>
				</div>
				<div
					v-if="$route.name != 'Homepage'"
					class="fw-M text-white fam-inter fs-20 w-75 ml-3"
				>
					{{ title || $route.meta.title }}
				</div>
				<!-- <div class="earned-coins fw-800 fs-12 fam-inter color-8A5A00 ml-1">
					<img src="../../assets/NewDashboard/Mobiledesign/coin.svg" alt="" />
					4.1k
				</div> -->
				<div
					v-if="$route.name != 'Homepage'"
					class="ml-2 ncd-notification-wrap pointer"
					@click="openSearch"
				>
					<img
						src="../../assets/NewDashboard/Mobiledesign/newheadersearch.svg"
						alt=""
					/>
				</div>
				<div
					class="ml-2 ncd-notification-wrap pointer"
					@click="gotoNotification"
				>
					<img
						:src="
							notificationCount > 0
								? require('../../assets/NewDashboard/Mobiledesign/notification.svg')
								: require('../../assets/NewDashboard/Mobiledesign/notivthoutred.svg')
						"
						alt="Notifications"
					/>
				</div>
			</section>
			<section
				v-if="$route.name == 'Homepage'"
				class="ncd-top-search-input position-relative mt-16px pointer"
				@click="openSearch"
			>
				<img
					src="../../assets/NewDashboard/Mobiledesign/newsearch.svg"
					class="ncd-search-img-pos"
					alt=""
				/>
				<b-form-input
					placeholder="Search for jobs, skills, companies..."
					readonly
					@click="openSearch"
					@focus="openSearch"
				></b-form-input>
			</section>
		</div>

		<!-- Search Overlay for Mobile & Desktop -->
		<div v-show="searchActive" class="search-suggestion-container">
			<img
				id="hideinmobile"
				@click="closeSearchDropdown"
				class="hp-whitecross-pos pointer"
				src="../../assets/newdesign/home/whitecross.svg"
				alt="Close"
			/>
			<div :class="{ 'extra-div': searchActive }"></div>
			<!-- Expanded Search Container -->
			<div class="header-center-area" ref="searchContainer">
				<!-- Tabs -->
				<div class="search-tabs-container">
					<div
						class="search-tab"
						@click="selectTab('job')"
						:class="selectedTab == 'job' ? 'active' : ''"
					>
						Jobs
					</div>
					<span class="divider">|</span>
					<div
						class="search-tab"
						@click="selectTab('assessment')"
						:class="selectedTab == 'assessment' ? 'active' : ''"
					>
						Assessments
					</div>
					<span class="divider">|</span>
					<div
						class="search-tab"
						@click="selectTab('course')"
						:class="selectedTab == 'course' ? 'active' : ''"
					>
						Courses
					</div>
				</div>

				<!-- Search Bar Wrapper (when search is active) -->
				<div class="search-bar-wrapper is-active">
					<div class="d-flex gap-2 w-100 align-items-center">
						<img
							id="hideinlaptop"
							class="shadow pointer"
							src="../../assets/guestHeader/search-back.svg"
							alt="Close Search"
							@click="closeSearchDropdown"
						/>
						<div class="header-search">
							<b-form-input
								ref="headerSearchInput"
								type="text"
								name="global-search"
								placeholder="Search.."
								v-model="searchQuery"
								@input="onSearchInput"
								@keydown.enter.native.prevent="
									performSearch(getLiveSearchQuery())
								"
								autocomplete="off"
								autocapitalize="off"
								autocorrect="off"
								spellcheck="false"
							></b-form-input>
							<img
								src="../../assets/guestHeader/darksearchicon.svg"
								alt="Search Icon"
								class="pointer"
								@click="performSearch(getLiveSearchQuery())"
							/>
						</div>
					</div>

					<!-- Search Dropdown Content Component -->
					<SearchDropdown
						:isVisible="searchActive"
						:selectedTab="selectedTab"
						:headerSearchQuery="searchQuery"
						:headerSearchSuggestion="searchSuggestion"
						:isSearching="isSearchLoading"
						@close-modal="closeSearchDropdown"
						@click-history="handleHistorySelection"
						@openResumeClinic="openResumeClinicModal"
					/>
				</div>
			</div>
		</div>

		<!-- Resume Clinic Modal -->
		<ResumeClinicModal
			v-if="showResumeClinicModal"
			:showModal="showResumeClinicModal"
			@modalClose="closeResumeClinicModal"
			:showfromhelpsection="false"
			:clinicDatafromhs="resumeClinicData"
			@openLoginModal="openLoginModal"
			@openLoginModalWithJobID="openLoginModalWithJobID"
		/>
	</section>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import menuItems from "@/utils/sideBarMenu.js";
import {
	getCandInfo,
	getCandidatePrimaryProfile,
	resumeAnalysis,
} from "@/utils/apiFunctions.js";
import SearchDropdown from "@/components/fixedcomponents/SearchDropdown.vue";
import ResumeClinicModal from "@/components/BuilderPage/ResumeclinicModal.vue";
import globalSearchMixin from "@/components/mixin/globalSearchMixin";
import EventBus from "@/utils/EventBus";

import MainLeftpart from "../LandingPage/MainLeftpart.vue";
export default {
	name: "NcdTopContainer",
	mixins: [globalSearchMixin],
	data() {
		return {
			showsidebar: false,
			collapseTimeout: null,
			menuItems: menuItems,
			selectedTab: "job",
			searchActive: false,
			showResumeClinicModal: false,
			resumeClinicData: {},
		};
	},
	components: {
		MainLeftpart,
		SearchDropdown,
		ResumeClinicModal,
	},
	computed: {
		...mapGetters("userVUEX", {
			userInfo: "getUserInfo",
			showUnreadCount: "getUnreadCount",
			showNotificationCount: "getNotificationCount",
		}),
		...mapGetters("candidateVUEX", {
			candidateInfo: "getcandidateInfo",
		}),
		// Total notification count from the store (same source as the bell icon
		// switch). The icon shows the "with red" bell whenever there is any
		// notification, otherwise the plain/no-red bell.
		notificationCount() {
			return this.showNotificationCount || 0;
		},
		// Unread notification count from the store, same source as NewCandidateDashboard
		unreadCount() {
			return this.showUnreadCount || 0;
		},
		// Candidate name from the store, same source as MainLeftpart
		firstName() {
			const c = this.candidateInfo || {};
			if (c.firstName) return c.firstName;
			if (c.fullName) return c.fullName.trim().split(" ")[0];
			return c.name || "Candidate";
		},
		jobTitle() {
			const c = this.candidateInfo || {};
			return c.designation || c.experienceLevelFormatted || c.role || " ";
		},
		location() {
			const c = this.candidateInfo || {};
			return (
				c.location ||
				c.currentLocation ||
				c.city ||
				c.currentLocationCity ||
				" "
			);
		},
		isFirstTimeUser() {
			return this.$store.getters["userVUEX/getIsFirstTimeUser"];
		},
	},
	watch: {
		showsidebar(val) {
			if (val) {
				this.cancelCollapse();
			} else {
				this.scheduleCollapse();
			}
		},
		searchActive(val) {
			if (val) {
				this.selectedTab = "job";
				document.body.style.overflow = "hidden";
			} else {
				document.body.style.overflow = "";
			}
		},
	},
	async created() {
		EventBus.$on("login-success", this.fetchCandidateInfo);
		EventBus.$on("onboarding-fetch-post-login", this.fetchCandidateInfo);
		await this.fetchCandidateInfo();
	},
	mounted() {
		document.body.addEventListener("click", this.handleClickOutside);
		document.addEventListener("mousedown", this.handleDocumentClick, true);
	},
	beforeDestroy() {
		document.body.removeEventListener("click", this.handleClickOutside);
		document.removeEventListener("mousedown", this.handleDocumentClick, true);
		document.body.style.overflow = "";
		EventBus.$off("login-success", this.fetchCandidateInfo);
		EventBus.$off("onboarding-fetch-post-login", this.fetchCandidateInfo);
	},
	props: {
		title: {
			type: String,
			default: "",
		},
		recruitersCount: {
			type: [Number, String],
			default: 6,
		},
	},
	methods: {
		async fetchCandidateInfo() {
			if (!this.candidateInfo || !this.candidateInfo._id) {
				try {
					const response = await getCandInfo(this.$route.query.id);
					let localCandidateInfo = null;
					if (response.status === 200) {
						localCandidateInfo = response.data.data;
					} else if (response.status === 404) {
						const res2 = await getCandidatePrimaryProfile();
						localCandidateInfo = res2.data.data;
					}
					if (localCandidateInfo) {
						this.$store.commit(
							"candidateVUEX/setCandidateInfo",
							localCandidateInfo
						);
					}
				} catch (error) {
					console.error(error);
				}
			}
		},
		scheduleCollapse() {
			this.collapseTimeout = setTimeout(() => {
				this.menuItems.forEach((item) => (item.showChildRoutes = false));
			}, 300);
		},
		cancelCollapse() {
			if (this.collapseTimeout) {
				clearTimeout(this.collapseTimeout);
				this.collapseTimeout = null;
			}
			this.menuItems.forEach((menu) => {
				menu.showChildRoutes = this.checkActive(menu);
			});
		},
		handleSubmenuClick(submenu) {
			Promise.resolve(submenu.onClick(this.$router)).catch(() => {});
			this.showsidebar = false;
		},
		bindSidebarIcon(menu) {
			let iconFile = "";
			try {
				iconFile = menu.isHovered
					? menu.hoverIcon
					: this.checkActive(menu)
					? menu.activeIcon
					: menu.icon;
				return require(`@/assets/sidebar/MobSidebar/${iconFile}`);
			} catch (e) {
				console.warn("Icon not found:", menu.label, iconFile);
				return "";
			}
		},
		checkActive(menu) {
			if (menu.label == "Job Search") {
				return (
					this.$route.name === "JobSearch" &&
					this.getBoolean(this.$route.query.bookmarked) !== true
				);
			} else if (menu.label == "Saved Jobs") {
				return (
					this.$route.name === "JobSearch" &&
					this.getBoolean(this.$route.query.bookmarked) === true
				);
			} else if (menu.childRoutes?.length) {
				return menu.childRoutes.some(
					(child) =>
						child.routeName && child.routeName.includes(this.$route.name)
				);
			} else if (menu.routeName && menu.routeName.includes(this.$route.name)) {
				return true;
			}
			return false;
		},
		showSidebarMenu(menu) {
			if (menu.label == "My Interview") {
				return this.userInfo.isPanelistVerified;
			}
			return true;
		},
		getBoolean(value) {
			return value === "true" || value === true;
		},
		handleClickOutside(event) {
			const sidebar = document.querySelector(".side-nav-main");
			if (sidebar && !sidebar.contains(event.target)) {
				this.showsidebar = false;
			}
		},
		handleDocumentClick(event) {
			if (!this.searchActive) return;
			if (
				!event.target.closest(
					".search-bar-wrapper, .search-tabs-container, .header-search"
				)
			) {
				this.closeSearchDropdown();
			}
		},
		goToProfileVisibility() {
			this.$router.push({ name: "ProfileVisibility" }).catch(() => {});
		},
		goToResumeBuilder() {
			this.$router.push({ name: "CandidateDashboard" }).catch(() => {});
		},
		gotoNotification() {
			this.$router.push({ path: "/notifications" }).catch(() => {});
		},
		/* ------- Search methods (self-contained, globalSearchMixin provides search state/mixins) ------- */
		openSearch() {
			this.selectedTab = "job";
			this.searchQuery = "";
			this.searchSuggestion = [];
			this.searchActive = true;
			this.getRecentSearches("job");
			this.getTrendingTagsData("job");
			this.$nextTick(() => {
				if (this.$refs.headerSearchInput) {
					const el =
						this.$refs.headerSearchInput.$el || this.$refs.headerSearchInput;
					if (el && el.focus) el.focus();
				}
			});
		},
		closeSearchDropdown() {
			this.searchActive = false;
			this.selectedTab = "job";
			this.searchQuery = "";
			this.searchSuggestion = [];
		},
		selectTab(data) {
			this.selectedTab = data;
			this.searchQuery = "";
			this.searchSuggestion = [];
			this.getRecentSearches(data);
			this.getTrendingTagsData(data);
		},
		getLiveSearchQuery() {
			const inputRef = this.$refs.headerSearchInput;
			if (!inputRef) return (this.searchQuery || "").toString();

			const rootEl = inputRef.$el || inputRef;
			if (rootEl && typeof rootEl.value === "string") {
				return rootEl.value;
			}

			const nestedInput =
				rootEl && rootEl.querySelector ? rootEl.querySelector("input") : null;
			return nestedInput && typeof nestedInput.value === "string"
				? nestedInput.value
				: (this.searchQuery || "").toString();
		},
		handleHistorySelection(query) {
			this.searchQuery = query;
			this.performSearch(query);
		},
		performSearch(forcedQuery = null) {
			const query = (
				forcedQuery ??
				this.getLiveSearchQuery() ??
				this.searchQuery
			)
				.toString()
				.trim();
			const type = this.selectedTab;
			if (!query) return;

			this.searchQuery = query;
			this.closeSearchDropdown();
			this.handleEnterSearch(query, type);
		},
		async openResumeClinicModal() {
			await this.fetchResumeClinicData();
			this.showResumeClinicModal = true;
		},
		async fetchResumeClinicData() {
			try {
				const res = await resumeAnalysis();
				if (res.status === 200) {
					this.resumeClinicData = res.data?.data?.analysis || {};
				}
			} catch (error) {
				console.log(error);
			}
		},
		closeResumeClinicModal() {
			this.showResumeClinicModal = false;
		},
		openLoginModal(uuid) {
			this.$store.commit("userVUEX/SET_RESUME_UUID", uuid);
			this.$store.commit("userVUEX/setresumeJobid", null);
			EventBus.$emit("open-login-modal");
		},
		openLoginModalWithJobID(jobId, uuid) {
			this.$store.commit("userVUEX/SET_RESUME_UUID", uuid);
			this.$store.commit("userVUEX/setresumeJobid", jobId);
			EventBus.$emit("open-login-modal");
		},
	},
};
</script>

<style scoped>
@media (max-width: 1028px) {
	.eyeicon-shadow {
		width: 22px;
		height: 22px;
		background: #ffffff;
		border: 1px solid #e9e9e9;
		box-shadow: 0px -2px 5px rgba(255, 255, 255, 0.9),
			0px 4px 10px rgba(0, 0, 0, 0.1);
		border-radius: 16px;
		margin-bottom: 2px;
	}
}
@media (max-width: 1028px) {
	.ncd-top-container {
		padding-top: env(safe-area-inset-top);
	}
	.ncd-top-firstcard {
		padding: 10px 0px 10px 16px;
		height: 42px;
		background: linear-gradient(
				90deg,
				rgba(32, 99, 155, 0.04) 0%,
				rgba(11, 34, 53, 0.04) 78.8%
			),
			#ffffff;
	}
	.ncd-top-search-container {
		padding: 16px;

		background: linear-gradient(
			67.34deg,
			#073787 0.46%,
			#073583 30.97%,
			#083078 58.08%,
			#0a2765 85.2%,
			#0c1c4b 111.18%,
			#0d1b49 113.44%
		);
		border-radius: 0px 0px 24px 24px;
	}
	.earned-coins {
		padding: 0 3px 0 2px;
		background: linear-gradient(
				294.58deg,
				rgba(255, 248, 217, 0.54) 18.18%,
				rgba(255, 232, 163, 0.54) 50%,
				rgba(247, 201, 104, 0.54) 81.82%
			),
			#ffffff;
		border: 1px solid #f1d27a;
		box-shadow: 0px 4px 10px rgba(184, 135, 36, 0.12);
		border-radius: 16px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.ncd-search-img-pos {
		position: absolute;
		left: 16px;
		top: 10px;
	}
}
.color-E0E0E0 {
	color: #e0e0e0;
}
.color-8A5A00 {
	color: #8a5a00;
}
.ncd-top-search-input .form-control {
	padding: 0px 16px 0 42px;
	height: 38px;
	background: #ffffff;
	box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.101961);
	border-radius: 12px;
}
.ncd-top-search-input .form-control::placeholder {
	font-family: "Inter", sans-serif;
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	color: #94a3b8;
}
.ncd-menu-icon {
	cursor: pointer;
}

.ncd-notification-wrap {
	position: relative;
	display: inline-flex;
	align-items: center;
	justify-content: center;
}
.ncd-notification-badge {
	position: absolute;
	top: -5px;
	right: -6px;
	min-width: 16px;
	height: 16px;
	padding: 0 4px;
	border-radius: 10px;
	background: #ff3b30;
	color: #ffffff;
	font-family: "Inter", sans-serif;
	font-size: 10px;
	font-weight: 700;
	line-height: 16px;
	text-align: center;
	white-space: nowrap;
}

@media (max-width: 1028px) {
	.hedaer-down-border {
		margin: 0 15px 0 16px;
		width: 92%;
		border-top: 3px solid transparent;
		border-image: repeating-linear-gradient(
				to right,
				#efefef 0,
				#efefef 12px,
				transparent 12px,
				transparent 18px
			)
			1;
	}
	.padding16px {
		padding: 16px;
	}
	.mh-side-nav {
		position: fixed;
		top: calc(0px + env(safe-area-inset-top));
		left: -3px;
		bottom: env(safe-area-inset-bottom);
		width: 0px;
		height: calc(
			100dvh - (env(safe-area-inset-bottom) + env(safe-area-inset-top))
		);
		box-shadow: 9px 4px 13px 0px #0000001a;
		z-index: 1500;
		overflow: hidden;
		background: linear-gradient(134.23deg, #ffffff 5.69%, #ebf0fc 96.31%);
		border: 1.5px solid #e9e9e9;
		border-radius: 0px 36px 36px 0px;
		padding-bottom: env(safe-area-inset-bottom);
	}
	.mh-side-nav:hover {
		width: 215px;
		overflow-y: auto;
		overflow-x: hidden;
	}
	.mhfixedwidth {
		width: 285px !important;
		padding: 16px;
	}
	.mhtrans {
		width: 0px !important;
	}
	.mh-side-menu-main li img {
		padding-right: 10px;
		cursor: pointer;
	}
	.mh-side-menu-main {
		padding-left: 0px;
		overflow-y: auto;
		overflow-x: hidden;
		height: calc(100dvh - 50px);
	}
	.mh-side-menu-main ul li {
		margin: 12px 12px;
		white-space: nowrap;
		position: relative;
	}
	.mh-activenavclass-dropdown {
		background-color: transparent;
		border-radius: 4px;
		padding: 7px 8px;
		color: #20639b !important;
		font-family: "Montserrat", sans-serif;
		font-size: 14px;
		font-weight: 600;
	}
	.mh-inactivenavclass-dropdown {
		background-color: transparent;
		border-radius: 15px;
		padding: 7px 8px;
		color: #324054 !important;
		font-family: "Montserrat", sans-serif;
		font-size: 14px;
		font-weight: 500;
	}
	.mh-selected-suboption {
		background: #20639b14;
		font-family: "Montserrat", sans-serif;
		font-size: 12px;
		font-weight: 600;
		color: #20639b;
		border-radius: 4px;
		padding: 7px 10px;
		margin: 2px 0;
		position: relative;
	}
	.mh-unselected-suboption {
		background: transparent;
		font-family: "Montserrat", sans-serif;
		font-size: 12px;
		font-weight: 500;
		color: #344054;
		border-radius: 4px;
		padding: 7px 10px;
		margin: 2px 0;
	}
	.sel-line-sidebar {
		background: #ad1927;
		height: 25px;
		width: 5px;
		border-radius: 0 3px 3px 0;
		position: absolute;
		left: -24px;
	}
}

/* ===== Search overlay (self-contained) ===== */

/* Mobile Search Overlay (max-width: 1028px) */
@media only screen and (max-width: 1028px) {
	.ncd-top-container {
        padding-top: env(safe-area-inset-top);
    }
	.search-suggestion-container {
		position: fixed;
		top: calc(0px + env(safe-area-inset-top));
		left: 0;
		width: 100vw;
		max-width: 100vw;
		height: 100vh;
		z-index: 2069;
		background: #f7f7f7;
		overflow-x: hidden;
		overflow-y: auto;
	}
	.search-suggestion-container .header-center-area {
		position: relative;
		width: 100%;
		padding: 15px 5px;
		pointer-events: auto;
		height: fit-content;
	}
	.search-suggestion-container .search-tabs-container {
		display: flex;
		align-items: center;
		justify-content: center;
		border: 1px solid #c4dcf6;
		border-radius: 74px;
		padding: 5px 6px;
		gap: 15px;
		background-color: white;
		margin-bottom: 10px;
		opacity: unset;
		width: 95%;
		left: 10px;
		transform: unset;
		height: unset;
		margin-left: auto;
		margin-right: auto;
	}
	.search-suggestion-container .search-tab {
		font-size: 16px;
		color: #4a7eff;
		cursor: pointer;
		font-weight: 400;
		padding: 4px;
		border-radius: 30px;
		transition: all 0.2s;
		line-height: 2;
	}
	.search-suggestion-container .search-tab.active {
		background: #4a7eff;
		color: white;
	}
	.search-suggestion-container .divider {
		color: #c4dcf6;
	}
	.search-suggestion-container .header-search {
		border: 1.5px solid #efefef;
		border-radius: 74px;
		position: relative;
		width: 100%;
		/* padding: 10px; */
		background: white;
		flex: 1;
		box-shadow: 0px 4px 2px rgba(0, 0, 0, 0.02), 0px 2px 2px rgba(0, 0, 0, 0.03),
			0px 0px 1px rgba(0, 0, 0, 0.03);
	}
	.search-suggestion-container .header-search img {
		position: absolute;
		left: 19px;
		top: 14px;
		width: 16px;
		height: 16px;
	}
	.search-suggestion-container .header-search .form-control {
		border: none;
		padding: 0.375rem 0.75rem 0.375rem 42px;
		border-radius: 50px;
	}
	.search-suggestion-container .header-search .form-control:focus {
		box-shadow: none;
	}
	.search-suggestion-container .search-bar-wrapper {
		position: fixed;
		padding: 15px;
		background-color: #ffffff;
		pointer-events: auto;
		box-shadow: 133px 38px 56px rgba(0, 0, 0, 0.01),
			75px 22px 47px rgba(0, 0, 0, 0.05), 33px 10px 35px rgba(0, 0, 0, 0.09),
			8px 2px 19px rgba(0, 0, 0, 0.1);
		border-radius: 20px 20px 0 0;
	}
	.search-suggestion-container .search-bar-wrapper.is-active {
		top: calc(78px + env(safe-area-inset-top));
		max-width: 95%;
		width: 95%;
		left: 11px;
	}
	.search-suggestion-container .search-dropdown-content {
		width: 100%;
		padding: 0px;
		padding-right: 2px;
		margin-top: -1px;
		box-shadow: none;
		min-height: unset;
		max-height: calc(100dvh - 168px);
		overflow: hidden auto;
		border-radius: 0 0 20px 20px;
	}
}

/* Desktop Search Overlay (min-width: 1029px) */
@media (min-width: 1029px) {
	.search-backdrop {
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		background: rgba(0, 0, 0, 0.15);
		backdrop-filter: blur(6px);
		-webkit-backdrop-filter: blur(6px);
		z-index: 1050;
	}
	.hp-whitecross-pos {
		position: absolute;
		right: 25px;
		top: 20px;
		z-index: 2070;
	}
	.search-suggestion-container {
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		z-index: 1060;
		pointer-events: auto;
	}
	.search-suggestion-container .search-tabs-container {
		display: flex;
		align-items: center;
		justify-content: center;
		border: 1px solid #c4dcf6;
		border-radius: 74px;
		padding: 4px 6px;
		gap: 15px;
		background-color: white;
		position: fixed;
		top: 16px;
		left: 50%;
		transform: translateX(-50%);
		height: 44px;
		z-index: 1062;
		box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.05);
	}
	.search-suggestion-container .search-tab {
		background: transparent;
		border: none;
		font-family: "Inter", sans-serif;
		font-size: 15px;
		color: #4a7eff;
		cursor: pointer;
		font-weight: 500;
		padding: 4px 16px;
		border-radius: 30px;
		transition: all 0.2s;
	}
	.search-suggestion-container .search-tab.active {
		background: #4a7eff;
		color: white;
	}
	.search-suggestion-container .divider {
		color: #c4dcf6;
	}
	.search-suggestion-container .search-bar-wrapper {
		position: fixed;
		top: 72px;
		left: 50%;
		transform: translateX(-50%);
		width: 90%;
		max-width: 650px;
		z-index: 1061;
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	.search-suggestion-container .header-search {
		border: 1.5px solid #efefef;
		box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
		border-radius: 74px;
		position: relative;
		width: 100%;
		height: 42px;
		background: white;
		display: flex;
		align-items: center;
	}
	.search-suggestion-container .header-search .form-control {
		border: none;
		padding: 0.375rem 0.75rem 0.375rem 44px;
		border-radius: 50px;
		background: transparent;
		font-size: 14px;
		height: 40px;
	}
	.search-suggestion-container .header-search .form-control:focus {
		box-shadow: none;
	}
	.search-suggestion-container .header-search img {
		position: absolute;
		left: 16px;
		top: 50%;
		transform: translateY(-50%);
		width: 16px;
		height: 16px;
	}
	.search-suggestion-container .search-dropdown-content {
		width: 100%;
		margin-top: 8px;
		background: #ffffff;
		border-radius: 20px;
		box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.12);
		max-height: calc(100vh - 140px);
		overflow-y: auto;
	}
}
</style>
